'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isPropValid = require('./isPropValid');

var _isPropValid2 = _interopRequireDefault(_isPropValid);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Filters our custom non-default React props.
 *
 * @param {Object} props The React props to filter.
 * @returns {Object} React-safe props.
 */


function getValidProps(props) {
  return Object.keys(props).reduce(function (validProps, prop) {
    if ((0, _isPropValid2.default)(prop)) {
      validProps[prop] = props[prop];
    }

    return validProps;
  }, {});
}

exports.default = getValidProps;